import {
  primaryColor,
  primaryDarkColor,
  successColor,
  dangerColor,
  primaryBoxShadow,
} from "assets/jss/xrs.js";
const fabStyle = {
  fabCameraContainer: {
    position: "fixed",
    bottom: "50px",
    left: "50%",
    marginLeft: "-40px",
    zIndex: "999",
    cursor: "pointer",
  },
  fabReturnContainer: {
    position: "fixed",
    bottom: "50px",
    marginLeft: "-30px",

    left: "30%",
    zIndex: "999",
    cursor: "pointer",
  },
  fabChangeCameraContainer: {
    position: "fixed",
    bottom: "50px",
    left: "70%",
    marginLeft: "-30px",

    zIndex: "999",
    cursor: "pointer",
  },
  fabIconHolder: {
    width: "50px",
    height: "50px",
    borderRadius: "100%",
    background: "#016fb9",
    boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
    "&:hover,&:focus": {
      backgroundColor: primaryColor[0],
      ...primaryBoxShadow,
    },
    "& i": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      fontStyle: "25px",
      color: "#ffffff",
    },
  },
  fab: {
    "&:hover,&:focus": {
      backgroundColor: primaryColor[0],
    },
    width: "80px",
    height: "80px",
    backgroundColor: primaryDarkColor[0],
  },
  fabReturn: {
    "&:hover,&:focus": {
      backgroundColor: primaryColor[0],
    },
    width: "60px",
    height: "60px",
    backgroundColor: primaryDarkColor[0],
  },
  fabLike: {
    "&:hover,&:focus": {
      backgroundColor: successColor[5],
      ...primaryBoxShadow,
    },
    width: "60px",
    height: "60px",
    backgroundColor: successColor[0],
  },
  fabDislike: {
    "&:hover,&:focus": {
      backgroundColor: dangerColor[5],
      ...primaryBoxShadow,
    },
    width: "60px",
    height: "60px",
    backgroundColor: dangerColor[0],
  },
};
export default fabStyle;
